module.exports = __webpack_public_path__ + "static/media/nrJKe79M8g.edb0feb6.jpg";